export default "__VITE_ASSET__DCT2Eoso__"